import { userCapabilities, userGatewayCapabilities } from 'helpers/constants';

export const actionTypes = {
    GET_GATEWAY_INFO_SETTINGS: 'powertrainTools/gatewayManagement/GET_GATEWAY_INFO_SETTINGS',
    GET_GATEWAY_INFO: 'powertrainTools/gatewayManagement/GET_GATEWAY_INFO',
    GET_GATEWAY_CONNECTED_ASSETS_SETTINGS: 'powertrainTools/gatewayManagement/GET_GATEWAY_CONNECTED_ASSETS_SETTINGS',
    GET_GATEWAY_CONNECTED_ASSETS: 'powertrainTools/gatewayManagement/GET_GATEWAY_CONNECTED_ASSETS',
    GET_USER_CAPABILITY_SETTINGS: 'powertrainTools/gatewayManagement/GET_USER_CAPABILITY_SETTINGS',
    GET_USER_CAPABILITY: 'powertrainTools/gatewayManagement/GET_USER_CAPABILITY',
    DOWNLOAD_INSTALLATION_REPORT: 'powertrainTools/gatewayManagement/DOWNLOAD_INSTALLATION_REPORT',
    DOWNLOAD_INSTALLATION_REPORT_SETTINGS: 'powertrainTools/gatewayManagement/DOWNLOAD_INSTALLATION_REPORT_SETTINGS',
    DOWNLOAD_DIAGNOSTIC_REPORT: 'powertrainTools/gatewayManagement/DOWNLOAD_DIAGNOSTIC_REPORT',
    DOWNLOAD_DIAGNOSTIC_REPORT_SETTINGS: 'powertrainTools/gatewayManagement/DOWNLOAD_DIAGNOSTIC_REPORT_SETTINGS',
    CLEAR_DOWNLOAD_DIAGNOSTIC_REPORT: 'powertrainTools/gatewayManagement/CLEAR_DOWNLOAD_DIAGNOSTIC_REPORT',
    CLEAR_STORE: 'powertrainTools/gatewayManagement/CLEAR_STORE',
    CLEAR_GATEWAY_CAPABILITIES: 'powertrainTools/gatewayManagement/CLEAR_GATEWAY_CAPABILITIES',
    CLEAR_INSTALLATION_REPORT: 'powertrainTools/gatewayManagement/CLEAR_INSTALLATION_REPORT',
    GET_CONNECTION_HISTORY_GATEWAY: 'powertrainTools/gatewayManagement/GET_CONNECTION_HISTORY_GATEWAY',
    GET_CONNECTION_HISTORY_GATEWAY_SETTINGS: 'powertrainTools/gatewayManagement/GET_CONNECTION_HISTORY_GATEWAY_SETTINGS',
    GET_CONNECTION_HISTORY_ASSET: 'powertrainTools/gatewayManagement/GET_CONNECTION_HISTORY_ASSET',
    GET_CONNECTION_HISTORY_ASSET_SETTINGS: 'powertrainTools/gatewayManagement/GET_CONNECTION_HISTORY_ASSET_SETTINGS',
    CLEAR_CONNECTION_HISTORY: 'powertrainTools/gatewayManagement/CLEAR_CONNECTION_HISTORY',
    GET_CONNECTED_HISTORY: 'powertrainTools/gatewayManagement/GET_CONNECTED_HISTORY',
    GET_CONNECTED_HISTORY_SETTINGS: 'powertrainTools/gatewayManagement/GET_CONNECTED_HISTORY_SETTINGS',
    CLEAR_CONNECTED_HISTORY: 'powertrainTools/gatewayManagement/CLEAR_CONNECTED_HISTORY',
};


export const GATWAY_CONNECTIVITY_STATUS = {
    CONNECTED: 'Connected',
    DISCONNECTED: 'Disconnected',
    CONNECTED_WITH_WARNING: 'Connected with warning'
};

const GATEWAY_CAPABILITIES = {
    FIRMWARE_UPDATE: userGatewayCapabilities.gatewayFirmwareUpdateTrigger,
    RESET_GATEWAY: userGatewayCapabilities.resetGateway,
    REMOTE_CONNECTION: userGatewayCapabilities.activateRemoteConnection,
    ASSET_ADMIN: userCapabilities.assetAdmin,
    DOWNLOAD_REPORT: userGatewayCapabilities.gatewayDiagnosticTrigger,
    IOT_DIAGNOSTIC_REPORT: userGatewayCapabilities.iotDiagnosticReport,
    DRIVE_ADMIN: userCapabilities.driveAdmin,
    REBOOT_GATEWAY: userGatewayCapabilities.rebootGateway,
    EXPORT_MESSAGE_ARCHIVE: userGatewayCapabilities.extractMessageArchive
};

export const GATEWAY_CAPABILITIES_LIST = Object.values(GATEWAY_CAPABILITIES);

export const RENAME_GATEWAY_REQUEST = 'gatewayDetails/RENAME_GATEWAY_REQUEST';
export const RENAME_GATEWAY = 'gatewayDetails/RENAME_GATEWAY';

export const gatewayRouteURL = 'tools';

export const POWERTRAIN_CONNECTION_STATUS = {
    CONNECTED: 'Online',
    DISCONNECTED: 'Offline'
};

export const TELEMETRY_CONNECTION_STATUS = {
    CONNECTED: 'Online',
    DISCONNECTED: 'Offline'
};

export const UNKNOWN_GATEWAY_TYPE = 'UnKnown';
export const PACKAGE_INSTALL_TIME = 'PackageInstallTime';
